var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "60 329.689 149.444 166.512",
    enableBackground: "new 60 329.689 149.444 166.512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main",
    transform: "translate(-25.000000, -23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(25.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo",
    fill: "#430098",
    d: "M194.458,329.689H74.987C66.66,329.689,60,336.35,60,344.675 v136.539c0,8.326,6.66,14.986,14.986,14.986h119.472c8.326,0,14.986-6.66,14.986-14.986V344.675 C209.445,336.35,202.784,329.689,194.458,329.689z M201.119,481.214c0,3.748-2.914,6.662-6.661,6.662H74.987 c-3.747,0-6.661-2.914-6.661-6.662V344.675c0-3.747,2.914-6.661,6.661-6.661h119.472c3.747,0,6.661,2.914,6.661,6.661V481.214z M97.465,471.224l18.732-16.65l-18.732-16.652V471.224z M164.903,403.787c-3.33-3.331-9.574-7.493-19.981-7.493 c-11.239,0-22.896,2.914-31.221,5.828v-47.456H97.049v72.017l11.655-5.413c0,0,19.149-8.742,35.801-8.742 c8.325,0,10.406,4.579,10.406,8.742v49.954h16.651v-49.954C171.98,420.022,171.98,410.864,164.903,403.787z M142.84,381.724 h16.65c7.493-8.742,11.24-17.484,12.489-27.058h-16.651C153.663,364.24,149.5,372.982,142.84,381.724z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.276e9377b3270886dc9512ba0d72506f.svg";
export { ForwardRef as ReactComponent };